export default function IosFlask() {
  return (
    <div
      className="ion-icon-ios-flask"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M391.016,382.994l-0.15-0.124L323.7,272H188.554l-66.549,110.855l-0.166,0.042l-0.177,0.302
		c-5.461,8.334-8.319,18.773-8.319,24.717c0,12.945,4.481,16.848,5.954,18.088c4.46,3.76,12.667,5.996,23.731,5.996H368.96
		c10.278,0,18.232-2.521,23.007-6.85c4.205-3.814,6.454-9.956,6.683-17.795c0.172-5.904-2.093-15.968-7.476-24.18L391.016,382.994z"
		/>
	<path d="M436.912,370.441L320,175V48h16V32H176v16h16v127L76.125,370.441C67.715,386.268,63.616,401.814,64.028,416
		c1.061,36.511,28.701,64,65.065,64h255.888c36.292,0,62.132-27.598,62.993-64C448.312,401.756,445.367,386.349,436.912,370.441z
		 M208,64h48v16h-48V64z M208,112h32v16h-32V112z M208,160h48v16h-48V160z M191.261,208H240v16h-58.179L191.261,208z
		 M414.64,408.041C413.934,432.289,398.763,448,368.96,448H143.027c-29.862,0-45.682-12.25-45.682-39.834
		c0-9.455,4.029-23.008,10.937-33.55L179.49,256h153.228l71.836,118.717C411.497,385.312,414.916,398.553,414.64,408.041z"/>
</g>
</svg>
`,
      }}
    />
  )
}
